import { HUBSPOT_PRODUCT_VALUE } from "./products";

const HUBSPOT_PORTAL_ID = "47654427";
const HUBSPOT_FORM_ID = "0fd3aa49-8045-435d-b22a-c182223105e5";

/**
 * Lee la cookie hubspotutk del navegador (creada por el Tracking Code de
 * HubSpot). Es necesaria para que el envío se enlace a un Contacto existente.
 */
export function getHubspotutkCookie() {
    if (typeof document === "undefined") return undefined;
    const match = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
    return match ? match[1] : undefined;
}

/**
 * Envía el lead a HubSpot.
 * Devuelve { ok: boolean, status?: number, body?: string }
 */
export async function submitToHubSpot({ name, email, phone, productId, productName, detalle }) {
    const url = `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${HUBSPOT_FORM_ID}`;

    const hutk = getHubspotutkCookie();

    const payload = {
        fields: [
            { name: "firstname", value: name },
            { name: "email", value: email },
            { name: "phone", value: phone },
            { name: "producto", value: HUBSPOT_PRODUCT_VALUE[productId] || productName },
            { name: "message", value: detalle },
        ],
        context: {
            pageUri: typeof window !== "undefined" ? window.location.href : "",
            pageName: typeof document !== "undefined" ? document.title : "",
            ...(hutk ? { hutk } : {}),
        },
    };

    try {
        const res = await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });

        const bodyText = await res.text();

        if (!res.ok) {
            // HubSpot suele devolver JSON con el detalle del error.
            // Lo dejamos en consola para diagnóstico (campos vacíos, opción inválida, etc.).
            console.error("[HubSpot] Envío rechazado", {
                status: res.status,
                body: bodyText,
                payload,
            });
            return { ok: false, status: res.status, body: bodyText };
        }

        // IMPORTANTE: HubSpot puede responder 200 e igual traer errores por campo
        // (ej. valor de dropdown inválido) dentro del propio body. Sin este log
        // ese caso pasa inadvertido y el submit se da por bueno sin estarlo.
        let parsedBody = null;
        try {
            parsedBody = JSON.parse(bodyText);
        } catch (_) {
            // body no era JSON parseable; se deja bodyText crudo abajo
        }
        if (parsedBody && Array.isArray(parsedBody.errors) && parsedBody.errors.length > 0) {
            console.warn("[HubSpot] Envío 200 pero con errores por campo", {
                errors: parsedBody.errors,
                payload,
            });
        } else {
            console.log("[HubSpot] Envío OK", { status: res.status, body: bodyText, payload });
        }

        return { ok: true, status: res.status, body: bodyText };
    } catch (err) {
        console.error("[HubSpot] Error de red o excepción", err);
        return { ok: false, error: err };
    }
}